// extracted by mini-css-extract-plugin
export default {"container":"fca-z","heading":"gca-z","links":"hca-z","linkBtn":"ica-z","disabled":"jca-z","linkUppercaseBold":"kca-z","copy":"lca-z","subCopy":"mca-z"};